import axios from "axios";
import React, { useState } from "react";
import { FaRegFileExcel } from "react-icons/fa";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import { FiDownload } from "react-icons/fi";
import BsaDateSelect from "../../components/BsaDateSelect";
import DownloadLoadingModal from "../../components/DownloadLoadingModal";
import VanishComponent from "../../components/VanishComponent";

function ConsentConsolidated({ id }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [noDownloadData, setNoDownloadData] = useState(false);
  const handleExcelDownload = async (provider) => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/user_consent_summary_report?report_type=${provider}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.data.response.status) {
        const url = res.data.response.data;

        handleDownloadFile(url);
      }
    } catch (error) {
      if (error.response.status === 404) {
        setNoDownloadData(true);
      }
    } finally {
      setDownloadLoading(false);
    }
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  function formatString(str) {
    if (str === null) return "---";
    if (str === "cams_aa_finserv") return "Cams AA Finserv";
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  }
  const fetchConsentSummary = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/users_consented_aggregators_summary`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data.length > 0) {
        setData(res.data);
        setLoading(false);
      } else {
        setNoData(true);
        setLoading(false);
      }
    } catch (error) {}
  };
  useState(() => {
    fetchConsentSummary();
  }, []);
  return (
    <>
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {!loading && !noData && (
        <div className=" mt-4 w-full overflow-auto max-h-[calc(100vh-190px)] bg-white rounded-lg py-4">
          <div className=" text-base font-bold mx-4 mb-4 flex justify-between items-center">
            <p> Consent Summary History</p>
            <button
              onClick={() => setShowModal(true)}
              className="text-sm font-semibold w-[124px] h-[30px] flex items-center justify-center bg-[#00394d] text-white rounded"
            >
              <span className=" mr-2">
                <FiDownload />
              </span>
              Download
            </button>
          </div>
          <div className="flex justify-between text-sm font-semibold px-4 h-[36px]">
            <p className="w-[18%]">Provider</p>

            <p className="w-[15%] text-right ">No of Hits</p>
            <p className="w-[20%] text-right ">No of users</p>
            <p className="w-[20%] text-right">Download</p>
          </div>
          {data.map((data, index) => {
            return (
              <>
                <div
                  key={index}
                  className={`flex justify-between text-xs font-medium h-[36px] items-center  px-4 ${
                    index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                  }`}
                >
                  <p className="w-[18%]">
                    {/* {key==="mutual_funds" || key==="stocks"?} */}
                    {formatString(data.provider) || "---"}
                  </p>

                  <p className="w-[15%] text-right">
                    {data.no_of_hits !== null ? data.no_of_hits : "---"}
                  </p>
                  <p className="w-[20%] text-right">
                    {data.no_of_users !== null ? data.no_of_users : "---"}
                  </p>
                  <p className="w-[20%] flex justify-end">
                    {" "}
                    <button
                      className={`p-[2px] border-2 border-[#00394d] rounded flex items-center justify-center `}
                      onClick={() => {
                        handleExcelDownload(data?.provider);
                      }}
                    >
                      <FaRegFileExcel
                        style={{
                          width: 16,
                          height: 16,
                          color: "#00394d",
                          fontWeight: 500,
                        }}
                      />
                    </button>
                  </p>
                </div>
              </>
            );
          })}
        </div>
      )}
      {showModal && (
        <BsaDateSelect
          setShowModal={setShowModal}
          id={id}
          downLoadType={"consolidated"}
        />
      )}
      {downloadLoading && <DownloadLoadingModal />}
      <VanishComponent
        error={noDownloadData}
        errorFunction={() => {
          setNoDownloadData(false);
        }}
        errorMessage={`No records found`}
        timeOut={5000}
      />
    </>
  );
}

export default ConsentConsolidated;
